import { WalletIndicatorTranslations } from "./wallet-indicator-pt-br";

export const WALLET_INDICATOR_EN_US: WalletIndicatorTranslations = {
	anticipation: "Available for anticipation",
	anticipationSmDevice: "Available for anticipation",
	anticipationTooltip: "Credit card transaction values that have not yet been settled.",
	seeWallet: "See Wallet",
	totalBalance: "Total balance",
	wallet: "Wallet",
	withdrawal: "Available for withdrawal",
	yourAccounts: "Your accounts",
	blockedBalance: "Blocked Value",
	blockedBalanceTooltip:
		"Values retained by Zig for operational reasons, future entries, transfers to Vendor and other blocks.",
	blockedByPendingWithdraws: "Withdrawals in process",
	blockedByPendingWithdrawsTooltip:
		"The total value corresponds to withdrawal requests being processed by Zig",
};
